import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './audit-history.reducer';
import { IAuditHistory } from 'app/shared/model/audit-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IAuditHistoryUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AuditHistoryUpdate = (props: IAuditHistoryUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { auditHistoryEntity, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/audit-history');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...auditHistoryEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.auditHistory.home.createOrEditLabel">Create or edit a AuditHistory</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : auditHistoryEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="audit-history-id">ID</Label>
                  <AvInput id="audit-history-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="videoOriginalJsonLabel" for="audit-history-videoOriginalJson">
                  Video Original Json
                </Label>
                <AvField id="audit-history-videoOriginalJson" type="text" name="videoOriginalJson" />
              </AvGroup>
              <AvGroup>
                <Label id="videoNewJsonLabel" for="audit-history-videoNewJson">
                  Video New Json
                </Label>
                <AvField id="audit-history-videoNewJson" type="text" name="videoNewJson" />
              </AvGroup>
              <AvGroup>
                <Label id="updatedByLabel" for="audit-history-updatedBy">
                  Updated By
                </Label>
                <AvField id="audit-history-updatedBy" type="string" className="form-control" name="updatedBy" />
              </AvGroup>
              <AvGroup>
                <Label id="updatedOnLabel" for="audit-history-updatedOn">
                  Updated On
                </Label>
                <AvField id="audit-history-updatedOn" type="date" className="form-control" name="updatedOn" />
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/audit-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  auditHistoryEntity: storeState.auditHistory.entity,
  loading: storeState.auditHistory.loading,
  updating: storeState.auditHistory.updating,
  updateSuccess: storeState.auditHistory.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuditHistoryUpdate);
